import React from 'react';
import TalAbility from './TalAiAbility';
import less from './FunctionalExperience.less';

class FunctionalExperience extends React.Component {
  render() {
    return (
      <div className={less.functionalExperience}>
        <div className={less.top}>{this.props.title}</div>
        <div className={less.bottom}>
          <div className={less.bottomCon}>
            <TalAbility production={this.props.production} />
          </div>
        </div>
      </div>
    );
  }
}

export default FunctionalExperience;
